<p-dialog
  [header]="headerKey | abpLocalization"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '30rem', maxWidth: '90vw' }"
  (onHide)="onHide()">
  <form class="d-flex flex-column gap-2" [formGroup]="form" (ngSubmit)="onSave()">
    <div class="field-row">
      <label for="statusName" class="form-label mb-0">
        {{ 'Settings::WorkEnvironment:StatusManagement:StatusName' | abpLocalization }}
      </label>
      <input
        id="statusName"
        [cxPendingLoader]="isValidating"
        type="text"
        pInputText
        class="form-control"
        maxlength="100"
        formControlName="name"
        [placeholder]="
          'Settings::WorkEnvironment:StatusManagement:StatusNamePlaceholder' | abpLocalization
        " />
    </div>
    <div class="field-row">
      <label for="typeId" class="form-label mb-0 mt-2">
        {{ 'Settings::WorkEnvironment:StatusManagement:Type' | abpLocalization }}
      </label>
      <cx-select
        class="type-combo"
        formControlName="typeId"
        appendTo="body"
        [showClear]="true"
        [label]="'Settings::WorkEnvironment:StatusManagement:Type' | abpLocalization"
        [placeholder]="
          'Settings::WorkEnvironment:StatusManagement:TypePlaceholder' | abpLocalization
        "
        [options]="typeOptions"
        optionLabel="label"
        optionValue="value"></cx-select>
    </div>
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'::Save' | abpLocalization"
      saveType="button"
      [disabled]="form.invalid || isBusy"
      [isSubmitting]="isBusy"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
